<template>
  <div v-if="showItem">
    <v-autocomplete
      :disabled="disabled || item.readonly || lockItem"
      :items="elementiSorted"
      item-text="descrizione"
      item-value="codice"
      :value="item.value"
      :label="item.label"
      :rules="rulesValidation"
      :return-object="true"
      clearable
      @change="onChange"
      @click:clear="onClear"
      @focus="onFocus"
      @blur="onBlur"
      :ref="item.model"
    >
<!--       <template v-slot:[`selection`]="{ item }">
        {{ item.codice + ' - ' + item.descrizione }}
      </template>     -->
    </v-autocomplete>
  </div>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import clienti from '@/services/clientiService.js'
  import { validazioni } from '@/mixins/validazioni.js'

  export default {
    name: 'emettitori',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: Number,
      defaultUsed: { type: Boolean, default: false }
    },
    data: (vm) => ({
      elementi: [],
      sourceArray: [],
      dialog: false,
      codice: '',
      descrizione: '',
      valoreInserito: '',
      oldValue: '',
      formAddFieldsValid: true
    }),
    async mounted() {
      const emettitori = await clienti.getEmettitori()
      this.elementi = emettitori.map(x => { return { codice: x._id, descrizione: x.ragioneSociale }})
      if (this.item.default && !this.defaultUsed) {
        this.onChange(this.item.default, null, true)
      }      
    },
    watch:{
      updateTrigger() {
        this.$forceUpdate()
      }
    },
    computed: {
      showItem() {
        return this.appoggio && this.appoggio.tipoBene === 'BUONOPASTO'
      },
      lockItem() {
        if (this.item && this.item.lockIf) {
          return !!_.get(this, this.item.lockIf, false)
        } else {
          return false
        }
      },
      elementiSorted() {
        const els = this.elementi
        const elSorted = els.sort(dynamicSortMultiple('descrizione'))
        return elSorted
      }    
    },
    methods: {
      onFocus(e) {
        this.oldValue = e.currentTarget.value
      },
      onBlur(e) {
        this.valoreInserito = e.currentTarget.value
        if (this.valoreInserito !== this.oldValue) {
          this.onChange(null, this.valoreInserito)
        }
      },
      onChange(item, descrizione, defaultUsed) {
        if (item) {
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: item, defaultUsed })
          this.oldValue = item.descrizione
        }
      },
      onClear() {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: null })
        this.oldValue = ''
      }
    }
  }
</script>
